import styled from '@emotion/styled';
import { DropdownButton, Popover } from '@ui-components/neo.tax';

import { screenMd, ZIndex } from '@neo.tax/shared/utils';

export const StyledDropdownButton = styled(DropdownButton)([
  { flex: 1 },
  screenMd({
    '.menu-value': {
      display: 'none',
    },
  }),
]) as typeof DropdownButton;

export const StyledPopover = styled(Popover)({
  padding: '1rem 1.5rem',
  minWidth: '20rem',
  zIndex: ZIndex.MODAL,
});
